import { render, staticRenderFns } from "./bankTab.vue?vue&type=template&id=783b7776&scoped=true&lang=pug"
import script from "./bankTab.vue?vue&type=script&lang=js"
export * from "./bankTab.vue?vue&type=script&lang=js"
import style0 from "./bankTab.vue?vue&type=style&index=0&id=783b7776&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "783b7776",
  null
  
)

export default component.exports